import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { METHODS, SERVICES } from '../../api/constants';
import { commonMoodlePayload } from '../../config';
import { makeRequest } from '../../api/api';
import { MOODLE_BACKEND_ROUTES } from '../../config/apiRoutes';
import { customToast } from '../../constant/constant';

export const getReferProgram = createAsyncThunk(
  'referNEarn/getReferProgram',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        {
          ...param,
          ...commonMoodlePayload,
          wsfunction: MOODLE_BACKEND_ROUTES.GET_REFER_PROGRAM,
          wstoken: thunkApi.getState().auth.token
        }
      );
      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const getMyReferral = createAsyncThunk(
  'referNEarn/getMyReferral',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        {
          ...param,
          ...commonMoodlePayload,
          wsfunction: MOODLE_BACKEND_ROUTES.GET_MY_REFERRAL,
          wstoken: thunkApi.getState().auth.token
        }
      );
      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);
export const postReferral = createAsyncThunk(
  'referNEarn/postReferral',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.POST,
        {
          ...param,
          ...commonMoodlePayload,
          wsfunction: MOODLE_BACKEND_ROUTES.POST_REFERRAL,
          wstoken: thunkApi.getState().auth.token
        }
      );
      setTimeout(() => {
        thunkApi.dispatch(resetReferred());
      }, 10000);
      thunkApi.dispatch(getMyReferral());
      if (!response?.data?.status) {
        customToast(
          'Referral Not Submitted',
          'The person who you have referred to, already exists with us',
          'error',
          3000
        );
      }

      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const referNEarn = createSlice({
  name: 'referNEarn',
  initialState: {
    loading: false,
    myreferralData: [],
    referPrograms: [],
    successReferred: false,
    myreferralLoading: false,
    programLoading: false,
    categoryData: []
  },
  reducers: {
    resetReferred(state, action) {
      state.successReferred = false;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getReferProgram.pending, (state) => {
      state.programLoading = true;
    });
    builder.addCase(getReferProgram.fulfilled, (state, action) => {
      state.referPrograms = action?.payload || [];
      if (action?.payload?.length) {
        const categories = action?.payload
          ?.map((item) => item.category)
          ?.filter((category) => category);
        const uniqueCategories = [...new Set(categories)];
        state.categoryData = uniqueCategories;
      }
      state.programLoading = false;
    });
    builder.addCase(getReferProgram.rejected, (state, action) => {
      state.referPrograms = [];
      state.programLoading = false;
    });
    builder.addCase(postReferral.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(postReferral.fulfilled, (state, action) => {
      state.loading = false;
      state.successReferred = action?.payload?.status;
    });
    builder.addCase(postReferral.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(getMyReferral.pending, (state) => {
      state.myreferralLoading = true;
    });
    builder.addCase(getMyReferral.fulfilled, (state, action) => {
      state.myreferralLoading = false;
      if (action?.payload?.length) {
        state.myreferralData = action?.payload.sort(
          (a, b) => new Date(b.timecreated) - new Date(a.timecreated)
        );
      }
    });
    builder.addCase(getMyReferral.rejected, (state) => {
      state.myreferralLoading = false;
      state.myreferralData = {};
    });
  }
});
export const { resetReferred } = referNEarn.actions;

export default referNEarn.reducer;
